import { render } from "./Inicio.vue?vue&type=template&id=5c42261c&scoped=true&ts=true"
import script from "./Inicio.vue?vue&type=script&lang=ts"
export * from "./Inicio.vue?vue&type=script&lang=ts"

import "./Inicio.vue?vue&type=style&index=0&id=5c42261c&lang=scss&scoped=true"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c42261c"]])

export default __exports__